import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { connect as connectFormik } from 'formik';
import { domainActions } from '../../../store/domainStore';
import { withLocalize } from "react-localize-redux";
import BbFormikCheckbox from "../../styling/bbFormikCheckbox";
import BbInput from "../../styling/bbInput";
import BbRadioWrapper from "../../styling/BbRadioWrapper";
import FinStatementsMultiSelectPopupButton from "./components/finStatementsMultiSelectPopupButton";
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";
import { unicornCountry, unicornAttributes, unicornAttribute, unicornFinStatementOrganizationValues } from "../../../store/marketingListStore";

const NEWEST = "newest";
const LASTX = "last-x"
const NEWERTHAN = "newer-than";

const FIN_STMT_TYPES = "fin-statement-types";
const FIN_STMT_TYPES_IFRS_CONSOLIDATED = "fin-statement-types-ifrs-consolidated";
const FIN_STMT_TYPES_IFRS_INDIVIDUAL = "fin-statement-types-ifrs-individual";
const FIN_STMT_TYPES_IFRS_ORIG = "fin-statement-types-ifrs-orig";
const FIN_STMT_VALUES = "fin-statement-values";
const FIN_STMT_RATIOS = "fin-statement-ratios";
const FIN_STMT_ORGANIZATIONS_TYPES = "fin-statement-values-organizations-types";

const style = { padding: "0 0.75em", minHeight: "3em" }

class Financial extends React.Component {
    render() {
        return (<>
            <div className="columns">
                <div className="column is-12" style={style}>
                    <div className="bb-radio-group-wrapper">
                        <div className="bb-radio-group-row">
                            <div className="control">
                                <BbRadioWrapper callback={() => this.props.formik.setFieldValue("financial.option", NEWEST)}
                                    checked={this.props.formik.values.financial.option === NEWEST}
                                    id={NEWEST}
                                    name="fin-year"
                                    value={NEWEST} label={this.props.translate("Search.Marketing.Latest")} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="columns">
                <div className="column bb-input-label-column" style={{ ...style }}>
                    <div className="bb-radio-group-wrapper">
                        <div className="bb-radio-group-row">
                            <div className="control">
                                <BbRadioWrapper callback={() => this.props.formik.setFieldValue("financial.option", LASTX)}
                                    checked={this.props.formik.values.financial.option === LASTX}
                                    id={LASTX}
                                    name="fin-year"
                                    value={LASTX} label={this.props.translate("Search.Marketing.LastXYears")} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column bb-input-column is-8" style={style}>
                    <div className="control">
                        <BbInput
                            name="financial.howMany"
                            label={""}
                            type="number"
                            disabled={this.props.formik.values.financial.option !== LASTX}
                            placeholder={{ type: 'inline' }}
                            style={{ paddingLeft: "0", paddingRight: "0" }} />
                    </div>
                </div>
            </div>
            <div className="columns">
                <div className="column bb-input-label-column" style={{ ...style }}>
                    <div className="bb-radio-group-wrapper">
                        <div className="bb-radio-group-row">
                            <div className="control">
                                <BbRadioWrapper callback={() => this.props.formik.setFieldValue("financial.option", NEWERTHAN)}
                                    checked={this.props.formik.values.financial.option === NEWERTHAN}
                                    id={NEWERTHAN}
                                    name="fin-year"
                                    value={NEWERTHAN} label={this.props.translate("Search.Marketing.NewerThan")} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column bb-input-column is-8" style={style}>
                    <div className="control">
                        <BbInput
                            name="financial.yearFrom"
                            label={""}
                            type="number"
                            disabled={this.props.formik.values.financial.option !== NEWERTHAN}
                            placeholder={{ type: 'inline' }}
                            style={{ paddingLeft: "0", paddingRight: "0" }} />
                    </div>
                </div>
            </div>

            <div className="columns">
                <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                    {unicornCountry() === 'sk' && <BbFormikCheckbox name="financial.incorrectStatementFlag" label={this.props.translate("Search.Marketing.IncorrectStatementFlag")} id="financial-incorrectStatementFlag" />}
                    {unicornCountry() === 'cz' && <BbFormikCheckbox name="financial.flagIFRS" label={this.props.translate("Search.Marketing.FlagIFRS")} id="financial-flagIFRS" />}
                </div>
            </div>

            <BbInput type='custom' noWidthOverride label={this.props.translate(`Search.Marketing.FinancialData${unicornCountry().toUpperCase()}`)} placeholder={{ type: 'column' }} custom={
                <FinStatementsMultiSelectPopupButton
                    finStatementTypesChanged={(all, parent) => {
                        this.props.formik.setFieldValue('financial.finStatementTypes', { all: all, parent: parent });
                        this.checkIfAll(FIN_STMT_TYPES, 'financial.finStatementTypes', all.length)
                    }}
                    finStatementRowsChanged={(all, parent) => {
                        this.props.formik.setFieldValue('financial.finStatementRows', { all: all, parent: parent });
                        this.checkIfAll(FIN_STMT_VALUES, 'financial.finStatementRows', all.length)
                    }}
                    selection={this.props.formik.values.financial}
                    typesName='finStatementTypes'
                    rowsName='finStatementRows'
                    finTypesDomain={FIN_STMT_TYPES}
                />
            }
            />

            {unicornCountry() === "sk" && <>
                <BbInput type='custom' noWidthOverride label={this.props.translate('Search.Marketing.FinancialDataIfrsOrig')} placeholder={{ type: 'column' }} custom={
                    <FinStatementsMultiSelectPopupButton
                        finStatementTypesChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementTypesIfrsOrig', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_TYPES_IFRS_ORIG, 'financial.finStatementTypesIfrsOrig', all.length)
                        }}
                        finStatementRowsChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementRowsIfrsOrig', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_VALUES, 'financial.finStatementRowsIfrsOrig', all.length)
                        }}
                        selection={this.props.formik.values.financial}
                        typesName='finStatementTypesIfrsOrig'
                        rowsName='finStatementRowsIfrsOrig'
                        finTypesDomain={FIN_STMT_TYPES_IFRS_ORIG}
                    />
                }
                />

                <BbInput type='custom' noWidthOverride label={this.props.translate('Search.Marketing.FinancialDataIfrsIndividual')} placeholder={{ type: 'column' }} custom={
                    <FinStatementsMultiSelectPopupButton
                        finStatementTypesChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementTypesIfrsIndividual', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_TYPES_IFRS_INDIVIDUAL, 'financial.finStatementTypesIfrsIndividual', all.length)
                        }}
                        finStatementRowsChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementRowsIfrsIndividual', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_VALUES, 'financial.finStatementRowsIfrsIndividual', all.length)
                        }}
                        selection={this.props.formik.values.financial}
                        typesName='finStatementTypesIfrsIndividual'
                        rowsName='finStatementRowsIfrsIndividual'
                        finTypesDomain={FIN_STMT_TYPES_IFRS_INDIVIDUAL}
                    />
                }
                />

                <BbInput type='custom' noWidthOverride label={this.props.translate('Search.Marketing.FinancialDataIfrsConsolidated')} placeholder={{ type: 'column' }} custom={
                    <FinStatementsMultiSelectPopupButton
                        finStatementTypesChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementTypesIfrsConsolidated', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_TYPES_IFRS_CONSOLIDATED, 'financial.finStatementTypesIfrsConsolidated', all.length)
                        }}
                        finStatementRowsChanged={(all, parent) => {
                            this.props.formik.setFieldValue('financial.finStatementRowsIfrsConsolidated', { all: all, parent: parent });
                            this.checkIfAll(FIN_STMT_VALUES, 'financial.finStatementRowsIfrsConsolidated', all.length)
                        }}
                        selection={this.props.formik.values.financial}
                        typesName='finStatementTypesIfrsConsolidated'
                        rowsName='finStatementRowsIfrsConsolidated'
                        finTypesDomain={FIN_STMT_TYPES_IFRS_CONSOLIDATED}
                    />
                }
                />
            </>               
            }
            {unicornCountry() === "sk" && <>
                    <BbInput type='custom' noWidthOverride label={this.props.translate('Report.FinancialRatios.Organizations')} placeholder={{ type: 'column' }} custom={
                                    <PopupMultiSelectButton
                                        title={this.props.translate('Report.FinancialRatios.Organizations')}
                                        data='fin-statement-values-organizations-values-all'
                                        name='fin-statement-values-organizations-values-all'
                                        selection={this.props.formik.values.financial.finStatementOrganizationsRows}
                                        handleChange={(all, parent) => {
                                            this.props.formik.setFieldValue('financial.finStatementOrganizationsRows',{ all: all, parent: parent });
                                        }}
                                        
                                    />
                    }/>
            </>}

            <BbInput type='custom' noWidthOverride label={this.props.translate('Search.Marketing.FinancialRatios')} placeholder={{ type: 'column' }} custom={
                <PopupMultiSelectButton
                    horizontal
                    popupSize='large'
                    data={FIN_STMT_RATIOS}
                    name={FIN_STMT_RATIOS}
                    onClick={() => this.props.ensureDomainData(FIN_STMT_RATIOS, { marketAttributes: unicornAttributes() })}
                    selection={this.props.formik.values.financial.finStatementRatios}
                    title={this.props.translate('MarketingList.Config.FinStmt.Ratios')}
                    handleChange={(all, parent) => {
                        this.props.formik.setFieldValue('financial.finStatementRatios', { all: all, parent: parent });
                        this.checkIfAll(FIN_STMT_RATIOS, "financial.finStatementRatios", all.length)
                    }}
                />
            }
            />
        </>);
    }

    checkIfAll = (domain, field, length) => {
        if (this.props.hasOwnProperty(domain) && this.props[domain].requestResult !== null && this.props[domain].requestResult.length === length) {
            this.props.formik.setFieldValue(`${field}.allSelected`, true);
            return true;
        }
        this.props.formik.setFieldValue(`${field}.allSelected`, false);
        return false;
    }
}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(Financial)));